interface UserDto {
    id?: number;
    externalId?: string;
    folderId?: string;
    email?: string;
    phoneNumber?: string;
    emailConfirmed?: boolean;
    firstName?: string;
    lastName?: string;
    active?: boolean;
    roles?: string[];
    permissions?: string[];
    companyId?: number;
}

export default class User {
    id: number;
    externalId: string | null;
    folderId: string | null;
    email: string;
    phoneNumber: string;
    emailConfirmed: boolean;
    firstName: string;
    lastName: string;
    active: boolean;
    roles: string[];
    permissions: string[];
    companyId: number | null;

    constructor(dto: Partial<UserDto> = {}) {
        this.id = dto.id ?? 0;
        this.externalId = dto.externalId ?? null;
        this.folderId = dto.folderId ?? null;
        this.email = dto.email ?? '';
        this.phoneNumber = dto.phoneNumber ?? '';
        this.emailConfirmed = dto.emailConfirmed ?? false;
        this.firstName = dto.firstName ?? '';
        this.lastName = dto.lastName ?? '';
        this.active = dto.active ?? false;
        this.roles = dto.roles ?? [];
        this.permissions = dto.permissions ?? [];
        this.companyId = dto.companyId ?? null;
    }

    get name() {
        return (this.firstName + ' ' + this.lastName).trim();
    }

    get initials() {
        const fi = this.firstName ? this.firstName.substr(0, 1) : '?';
        const li = this.lastName ? this.lastName.substr(0, 1) : '?';
        return (fi + li).toUpperCase();
    }

    get firstNameLastInitial() {
        const li = this.lastName ? this.lastName.substr(0, 1) : '?';
        return this.firstName + ' ' + li.toUpperCase() + '.';
    }

    get isSuperAdmin() {
        return this.roles.includes('Super Admin');
    }

    get isMasterAdmin() {
        return this.roles.includes('Master Admin');
    }

    get role() {
        if (this.roles.includes('Super Admin')) return 'Super Admin';
        if (this.roles.includes('Master Admin')) return 'Master Admin';
        if (this.roles.includes('Admin')) return 'Admin';
        if (this.roles.includes('Project Manager')) return 'Project Manager';
        if (this.roles.includes('User')) return 'User';
        return this.roles.length > 0 ? this.roles[0] : '';
    }
}
